import React, { useEffect } from "react";
import { trackHowToPlayViewed } from '../../utils/activityTracker';
import useAchievements from '../../hooks/useAchievements';
import { useAuth } from '../../contexts/AuthContext';
import "./SlayTheSpireHowToPlay.scss";

const HowToPlayContent = () => (
  <>
    <h2 className="slay-the-spire-how-to-play__title">How to Play</h2>
    <ul className="slay-the-spire-how-to-play__list">
      <li className="slay-the-spire-how-to-play__list-item">
        Try to guess the name of a <b>Slay the Spire</b> card chosen at random!
      </li>
      <li className="slay-the-spire-how-to-play__list-item">
        Each guess will be checked for matching <b>Class</b>, <b>Type</b>, <b>Cost</b>, <b>Behaviors</b>, <b>Target</b>, and <b>Rarity</b>.
      </li>
      <li className="slay-the-spire-how-to-play__list-item">
        <span className="slay-the-spire-how-to-play__highlight-color slay-the-spire-how-to-play__highlight-color--blue">Blue</span> means your guess matches the secret card in that category.<br />
        <span className="slay-the-spire-how-to-play__highlight-color slay-the-spire-how-to-play__highlight-color--yellow">Yellow</span> (for behaviors) means your guess shares at least one behavior.<br />
        <span className="slay-the-spire-how-to-play__highlight-color slay-the-spire-how-to-play__highlight-color--pink">Pink</span> means no match.
      </li>
      <li className="slay-the-spire-how-to-play__list-item">
        After <b>5 incorrect guesses</b>, you can unlock a hint that shows the card’s description!
      </li>
      <li className="slay-the-spire-how-to-play__list-item">
        Use the <b>Card Directory</b> to browse cards and filter by attributes.
      </li>
      <li className="slay-the-spire-how-to-play__list-item">
        Guess until you find the right card.
      </li>
    </ul>
    <div className="slay-the-spire-how-to-play__tip">
      <b>Tip:</b> After 5 attempts, you can reveal the hint to learn what the card does.
    </div>
  </>
);

const SlayTheSpireHowToPlay = ({ show, onClose, gameId }) => {
  const { handleNewAchievements } = useAchievements();
  const { isAuthenticated } = useAuth();
  
  // Track when the modal is shown (only for authenticated users)
  useEffect(() => {
    if (show && gameId && isAuthenticated) {
      const trackGuideView = async () => {
        const response = await trackHowToPlayViewed(gameId);
        if (response && response.newAchievements && response.newAchievements.length > 0) {
          handleNewAchievements(response.newAchievements);
        }
      };
      trackGuideView();
    }
  }, [show, gameId, isAuthenticated, handleNewAchievements]);

  if (!show) return null;

  return (
    <div className="slay-the-spire-how-to-play" onClick={onClose}>
      <div className="slay-the-spire-how-to-play__panel" onClick={e => e.stopPropagation()}>
        <button className="slay-the-spire-how-to-play__close-button" onClick={onClose}>
          ✕
        </button>
        <HowToPlayContent />
      </div>
    </div>
  );
};

export default SlayTheSpireHowToPlay;